import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

function usePersonSalaryService() {
  const getAmount = (personSalaryReport?: ApiModels.PersonSalaryReport) => {
    return (
      (personSalaryReport?.totalSalary ?? 0) +
      (personSalaryReport?.totalEmployerContribution ?? 0) +
      (personSalaryReport?.totalBenefits ?? 0)
    );
  };
  return { getAmount };
}

export default usePersonSalaryService;
